// extracted by mini-css-extract-plugin
module.exports = {"about":"style_about__1JRMh","card":"style_card__9DQZ7","text":"style_text__1jxAt","description":"style_description__2Owom","downloads":"style_downloads__nKctQ"};